import { render, staticRenderFns } from "./EditBroker.vue?vue&type=template&id=2ed386fc"
import script from "./EditBroker.vue?vue&type=script&lang=js"
export * from "./EditBroker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports